import { useCountryStore } from '@/stores/countryStore';

export function validateVAT(vatNumber: string, countryCode: string): boolean {
    const { vatRegexPatterns } = useCountryStore.getState();
    const patternString = vatRegexPatterns[countryCode.toUpperCase()];
    if (!patternString) {
        return false;
    }
    const pattern = new RegExp(patternString);
    return pattern.test(vatNumber);
}
